import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';

@Resource({
  type: 'dvcontentextendedcountries',
})
export class Dvcontentextendedcountry extends AtomResource {
  @Attribute({ key: 'gtm_container_id' }) gtmContainerId?: string;
  @Attribute({ key: 'ga_measurment_id' }) gaMeasurmentId?: string;

  @Relationship() country?: Country;
}

export class DvcontentextendedcountryConfig implements ResourceConfig {
  hosted = 'country';
  tables = {
    includes: ['country'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        translatable: false,
        displayed: true,
      },
      {
        columnDef: 'gtmContainerId',
        displayedDatas: [
          {
            path: ['gtmContainerId'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'GTM ID',
        displayed: true,
      },
      {
        columnDef: 'gaMeasurmentId',
        displayedDatas: [
          {
            path: ['gaMeasurmentId'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'GA ID',
        displayed: true,
      },
      {
        columnDef: 'didomiConsentId',
        displayedDatas: [
          {
            path: ['didomiConsentId'],
            class: 'mat-body-1',
            translatable: false,
          },
        ],
        header: 'Didomi ID',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'source',
      title: [
        {
          path: ['id'],
          translatable: false,
        },
      ],
    },
    elements: [
      {
        showEmpty: false,
        columns: false,
        list: [
          {
            icon: 'numbers',
            title: 'GTM ID',
            APIKey: 'gtmContainerId',
            value: {
              path: ['gtmContainerId'],
              translatable: false,
            },
            options: {
              copy: true,
            },
          },
          {
            icon: 'numbers',
            title: 'GA ID',
            APIKey: 'gaMeasurmentId',
            value: {
              path: ['gaMeasurmentId'],
              translatable: false,
            },
            options: {
              copy: true,
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'DV Content Extend',
        formGroup: 'dvContentExtend',
        list: [
          {
            type: 'text',
            title: 'GTM ID',
            formControl: 'gtmContainerId',
            APIKey: 'gtmContainerId',
            multiple: false,
            required: false,
            hint: 'Must begin with GTM- and be 11 characters',
          },
          {
            type: 'text',
            title: 'GA ID',
            formControl: 'gaMeasurmentId',
            APIKey: 'gaMeasurmentId',
            multiple: false,
            required: false,
            hint: 'Must begin with G- and be 12 characters',
          },
        ],
      },
    ],
  };
  resource = Dvcontentextendedcountry;
  resourceName = 'DV Content Extend Country';
  resourceKey = 'dvcontentextendedcountries';
  resourceKeySingle = 'dvcontentextendedcountry';
  includes = ['country'];
  filters = [];
}
